import React, { useContext } from 'react';

import cx from 'classnames';

import tableStyles from 'components/shared/Table/index.module.css';

import { CustomFontsContext } from '../context';
import s from './index.module.css';
import Item from './Item';
import useTable from './useTable';

function Table() {
  const { loadingFont, ...rest } = useContext(CustomFontsContext);
  const { isNoData, fontsCollection, handleCheck, activeFontIds, handleRemove } = useTable(rest);

  return (
    <table className={cx(tableStyles.table, s.table)}>
      <thead className={tableStyles.thead}>
        <tr>
          <th className={cx(tableStyles.cell, tableStyles.th)}>Active</th>
          <th className={cx(tableStyles.cell, tableStyles.th)}>File</th>
          <th className={cx(tableStyles.cell, tableStyles.th)}>Font Family</th>
          <th className={cx(tableStyles.cell, tableStyles.th)}>Font Style</th>
          <th className={cx(tableStyles.cell, tableStyles.th)}>Font Weight</th>
          <th className={cx(tableStyles.cell, tableStyles.th)}>Remove</th>
        </tr>
      </thead>
      <tbody className={tableStyles.tbody}>
        {isNoData ? (
          <tr>
            <td colSpan={6} className={cx(tableStyles.cell, tableStyles.cellTd, tableStyles.noDataText)}>
              {loadingFont ? 'Loading…' : 'No Data'}
            </td>
          </tr>
        ) : (
          fontsCollection.map((font) => (
            <Item
              key={font.id}
              font={font}
              checked={activeFontIds.includes(font.id)}
              onRemove={(id) => handleRemove(id)}
              onCheck={(id) => handleCheck(id)}
            />
          ))
        )}
      </tbody>
    </table>
  );
}

export default Table;
